import { Component, HostListener } from '@angular/core';
import { EventService } from '../../services/event.service';

@Component({
  selector: 'app-claim-page',
  templateUrl: './claim-page.component.html',
  styleUrls: ['./claim-page.component.scss']
})
export class ClaimPageComponent{

  isMobile = (window.matchMedia && window.matchMedia('(max-device-width: 1024px)').matches) || screen.width <= 1024;
  @HostListener('window:resize', ['$event'])
  currentLanguage: string = "en";
  onResize(event: any) {
    this.isMobile = (window.matchMedia && window.matchMedia('(max-device-width: 1024px)').matches) || screen.width <= 1024;
  }

  constructor(
    private eventService:EventService
  ) {
    this.eventService.getLang().subscribe((val: any) => {
      this.currentLanguage = val || 'en';
    });
    // // checking that claim live 
    // if(this.walletConnectService.claimStartDate > this.walletConnectService.currentDate){
    //   window.location.replace("/");
    // }
  }

  handleSocialClick(name: 'dex' | 'bridge' | 'block-explorer' | 'pepu-guide') {
    const urls = {
      dex: 'https://pepuswap.com/',
      bridge: 'https://pepubridge.com/',
      'block-explorer': 'https://pepuscan.com/',
      'pepu-guide': 'https://guide.pepeunchained.com',
    };
  
    const url = urls[name];
    if (url) {
      window.open(url, '_blank');
    } else {
      console.error('Invalid name:', name);
    }
  }  
}
